<template>
  <div class="wrapper">  
    <div style="float:right; padding: 10px 80px 10px 10px; position:relative; z-index:10;">
      Karte <b-switch v-model="liste" type="is-success" /> Liste
    </div>
    <br style="clear:both">

    <!-- Mapbox Karten-Initialisierung -->
    <div id="map" class="map" :style="{display: !liste ? 'block' : 'none'}">

      <b-collapse class="card filter-box" :open.sync="filterOpen" style="width: 50%; position:relative">
        <div slot="trigger" class="card-header" role="button">
          <p class="card-header-title">Filter der Angebote</p>
          <a class="card-header-icon">
            <b-icon :icon="filterOpen ? 'menu-down' : 'menu-up'"></b-icon>
          </a>
        </div>
        <div class="criteria">
          <b-field label="Kriterien"> 
            <section>
              <b-checkbox v-model="tags" v-for="tag in tag_collection" v-bind:value="tag" v-bind:key="tag" :native-value="tag">{{tag}}</b-checkbox>
            </section>
          </b-field>

          <b-button type="is-success" @click="search">GO</b-button>
        </div>
      </b-collapse>
    </div>

    <div id="liste" :style="{display: liste ? 'block' : 'none'}">
      <div class="posts-page">
        <div class="post-list">
          <PostPreview v-for="post in posts" :key="post.id" :post="post" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import db from "../db"
import PostPreview from '@/components/PostPreview'

export default {
  name: 'MapBox',
  components: {
    PostPreview
  },
  data() {
    return {
      tag_collection:[],
      posts: [],
      filterOpen: false,
      liste: false,
      filter: null,
      tags: []
    };
  },
  firestore: {
    posts: db.collection('posts')
  },
  mounted: function () {
    this.createMap()
  },
  created:function () {
    fetch("tag_collection.json")
      .then(r => r.json())
      .then(json => {this.tag_collection = json.tags})
  },
  methods: {
    search: function () {

      const mapboxgl = require('mapbox-gl/dist/mapbox-gl.js')

      var geoJSON= {"type": "geojson","data":  {"type": "FeatureCollection","features": []} };

      let query = db.collection('posts')
      
      if(this.tags.length) query = query.where('tags','array-contains-any', this.tags)
      
      query .get()
            .then(querySnapshot => {
              const documents = querySnapshot.docs.map(doc => doc.data())
              console.log(documents);

              if (this.map.getLayer('search-result')) {      
                this.map.removeLayer('search-result');
                this.map.removeSource('search-result');
              } 

            for (const key in documents) {

              let entry = documents[key]

              let temp =  {
                            "type": "Feature",
                            "geometry": {
                              "type": "Point",
                              "coordinates": [parseFloat(entry.long), parseFloat(entry.lat)]
                            },
                            "properties": entry
                          };

                geoJSON.data.features.push(temp);
              }
              
              // show layer
              this.map.addLayer({
                id: 'search-result',
                type: 'circle',
                source: geoJSON,
                paint: {
                  'circle-radius': 8,
                  'circle-color': '#DA2222',
                  'circle-opacity': 0.4
                }
              });

              // When a click event occurs on a feature in the places layer, open a popup at the location of the feature, with description HTML from its properties.
              this.map.on('click', 'search-result', (e) => {
                console.log('e', e);
                var coordinates = e.features[0].geometry.coordinates.slice();
                var title = e.features[0].properties.title;
                var description = e.features[0].properties.description;
                var name = e.features[0].properties.name;
                // var city = e.$store.loadedposts
              
              // Ensure that if the map is zoomed out such that multiple copies of the feature are visible, the popup appearsover the copy being pointed to.
              while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
              }

              new mapboxgl.Popup()
                .setLngLat(coordinates)
                .setHTML(
                  '<h3>' + title + '</h3>' + '<br>' + 
                  '<p>' + name + '</p>' + '<br>' + 
                  '<p>' + description.truncate(50) + '</p>' + '<br>'
                )
                .addTo(this.map);
              });

              // Change the cursor to a pointer when the mouse is over the places layer.
              this.map.on('mouseenter', 'search-result', () => {
                this.map.getCanvas().style.cursor = 'pointer';
              });
              
              // Change it back to a pointer when it leaves.
              this.map.on('mouseleave', 'search-result', () => {
                this.map.getCanvas().style.cursor = '';
              });

            });
    },
    createMap: function () {

      const mapboxgl = require('mapbox-gl/dist/mapbox-gl.js')

      // eslint-disable-next-line
      const MapboxGeocoder = require('@mapbox/mapbox-gl-geocoder')
      
      mapboxgl.accessToken = 'pk.eyJ1IjoibHVmdGRhdGVuaW5mbyIsImEiOiJjanJ1ZmRucmkwOGplNDNubWxud3U3NW42In0.Hm6WWq2iUg9fRZkNYRM7cg'
      
      // init the map
      this.map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/webuildcity/cjs1xyuwy011b1fnseuvc4r9f',
        center: [10.0062, 53.5189],
        zoom: 9.88,
        pitch: 0,
        minZoom: 2,
        maxZoom: 20,
        maxBounds: [[9.677192, 53.396666],
                    [10.315085, 53.770051]],
        attributionControl: false,
        hash: false
      });

      // show naturschutzgebiete layer
      this.map.on('load', () => {
        this.map.addSource('naturschutzgebiete', { type: 'geojson', data: './naturschutzgebiete-hamburg.geojson'});
        this.map.addLayer({ 'id': 'naturschutzgebiete',
                            'type': 'fill',
                            'source': 'naturschutzgebiete',
                            'paint': {
                              'fill-opacity': 0.5,
                              'fill-color': '#00A86B'
                            }
                          });
      })
  }}
}
</script>

<style lang="scss">
@import '@/assets/styles/main.scss';

.filter-box {
  background-color: $white;
  border-radius: 3px;
  top: 20px;
  box-shadow: 0 2px 3px rgba(0,0,0,0.30);
  font: 12px/20px 'Helvetica Neue', Arial, Helvetica, sans-serif;
  padding: 20px;
  position: absolute;  // <<---- Wichtiger Eintrag, nur deshalb AUF der Karte
  // right: 150px; // Definiert die Position des Infobox/Filter-Layers  
  left: 20px; // Definiert die Position des Infobox/Filter-Layers  
  z-index: 1; // <<-- definiert, dass .filter-box ganz unten liegt... andere Elemente mit z-index 2+ lägen darüber
}

#map {
  height: 600px;
  width: 100%;
}

.mapboxgl-popup-content {
  background-color: #ABD057;
   max-width: 200px;
}

.mapboxgl-popup-content h3 {
  // background: #91c949;
  color: #fff;
  margin: 0;
  display: block;
  padding: 10px;
  border-radius: 3px 3px 0 0;
  font-weight: 700;
  margin-top: -15px;
}

.headline {
  display: flex;
  justify-content: center;
  text-transform: uppercase;
  margin-top: 20px;
  color: $primaryBorder;
}

.posts-page {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 30px;
}

.post-list {
  display: flex;
  padding: 20px;
  box-sizing: border-box;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.criteria {
  margin-top: 20px
}

</style>